import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField } from "@material-ui/core";
import "./NotesDialog.css";
import { isNullOrEmpty } from "./Util";

export class NotesDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			NoteData: {},
			open: false,
		};

		this.onClose = this.onClose.bind(this);
		this.saveData = this.saveData.bind(this);
		this.delete = this.delete.bind(this);
	}

	componentDidUpdate(prevProps) {
		if ((this.props.Note.notes_id !== prevProps.Note.notes_id && this.props.visible) || (this.props.visible !== prevProps.visible && this.props.visible)) {
			this.setState({ NoteData: this.props.Note, open: true });
		}
	}

	async saveData() {
		var toSave = this.state.NoteData;
		toSave.buildings_id = this.props.BuildingsID;
		await fetch("Building/SaveNote", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ noteData: toSave }),
		});

		this.onClose();
	}

	async delete() {
		if (!window.confirm("Are you sure you want to delete this note?")) return;

		var dt = await fetch("Building/DeleteNote", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(this.props.Note.notes_id),
		});

		dt = await dt.text();

		if (!isNullOrEmpty(dt)) {
			alert(dt);
		}
		this.onClose();
	}
	dynamicOnChange = (event) => {
		var columnName = null;
		if (event.target.nodeName === "INPUT" || event.target.nodeName === "TEXTAREA") {
			columnName = event.target.attributes.columnname.value;
		} else if (event.currentTarget.nodeName === "LI") {
			columnName = event.currentTarget.dataset.columnname;
		}

		var data = this.state.NoteData;
		data[columnName] = event.target.value;
		if (event.target.type === "checkbox") {
			data[columnName] = event.target.checked;
		}

		this.setState({ NoteData: data });
	};

	onClose() {
		this.setState({ open: false });
		this.props.OnClose && this.props.OnClose();
	}

	render() {
		var baseData = this.state.NoteData;
		var inputProps = { readOnly: false };
		var labelProps = { shrink: true };
		return (
			<Dialog open={this.state.open} onClose={this.onClose} maxWidth="md">
				<DialogTitle>{baseData.notes_id ? baseData.title : "New Note"}</DialogTitle>
				<DialogContent>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "title" }} label="Title" value={baseData.title} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} multiline={true} fullWidth={true} inputProps={{ columnName: "description" }} label="Description" className="note-control" value={baseData.description} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.saveData} color="primary">
						Save
					</Button>
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
					{!isNullOrEmpty(this.props.Note.notes_id) && (
						<Button onClick={this.delete} color="primary">
							Delete
						</Button>
					)}
				</DialogActions>
			</Dialog>
		);
	}
}
